import { RegisterOptions } from "react-hook-form";

export interface IExpandableFormGroup {
  expandable?: boolean;
  expandableLimit?: number;
  expandableMoreText?: string;
  expandableLessText?: string;
}

// form builder

export enum IFieldType {
  text = "text",
  email = "email",
  password = "password",
  checkbox = "checkbox",
  checkboxGroup = "checkboxGroup",
  search = "search",
  select = "select",
  staticText = "staticText",
}

export interface IBaseField {
  type: IFieldType;
  name: string;
  label: string;
  hideLabel?: boolean;
  prefixText?: string;
  labelIcon?: string | JSX.Element;
  placeholder?: string;
  validation?: RegisterOptions;
}

export interface IInputField extends IBaseField {
  value?: string;
  onChange?: (data: any) => void;
}

export interface IOption extends IBaseField {
  value: string;
  disabled?: boolean;
}

export interface ICheckboxField extends IOption {}

export interface ICheckboxGroup extends IBaseField, IExpandableFormGroup {
  options: ICheckboxField[];
  value?: string[];
}

export interface ISelectField extends IBaseField {
  options: IOption[];
  value?: string;
}

export interface IStaticText extends IBaseField {
  type: IFieldType.staticText;
  label: string;
}

export type IField = IInputField | ICheckboxGroup | ISelectField | IStaticText;

export interface IFormSchema {
  fields: IField[];
  defaultValues?: Record<string, any>;
  resetDefaultValues?: boolean;
  layout?: "inline" | "block";
  disableAfterSubmit?: boolean;
  submitMode?: "default" | "onValid" | "onDirty";
}

// newsletter form

export interface INewsletterOption {
  title: string;
  id: string;
  audience: string;
  segment?: string;
}

export interface INewsletterSubmitData {
  email: string;
  audiences?: {
    audience_id: string;
    segment_id?: string;
    unique_id: string;
  }[];
  consent: boolean;
}

// search form

export interface ISearchSubmitData {
  search: string;
}

// tool search facets

export enum ToolFacetType {
  term = "term",
  theme = "theme",
  type = "toolType",
  audience = "audience",
}

export enum ToolboxFacetType {
  type = "subToolType",
  phase = "subToolPhase",
}

export interface IFacetItem {
  id: string;
  label: string;
}

export interface IFacet {
  label: string;
  labelIcon?: string;
  slug: string;
  options: IFacetItem[];
  prefixText?: string;
}

export interface IToolFacet extends IFacet {
  key: ToolFacetType;
}

export interface IToolboxFacet extends IFacet {
  key: ToolboxFacetType;
}

export type ActiveToolFacetType = Partial<
  Record<ToolFacetType, string | string[] | null | undefined>
>; // term or selected option IDs

export type ActiveToolboxFacetType = Partial<
  Record<ToolboxFacetType, string | string[] | null | undefined>
>; // term or selected option IDs

export interface IActiveFacet {
  label: string;
  activeOptions: IActiveFacetOption[] | undefined;
}

export interface IActiveFacetOption {
  label: string;
  onClick: () => void;
}
